import React, { useEffect, useState, useContext, useRef } from "react";
import downloadicon from "../assets/img/Frame 47751.png";
import API from "../pages/Services/Baseservice";
import { useLocation, useNavigate } from "react-router-dom";
import { LanguageContext } from "../pages/languagecontext";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import ClipLoader from "react-spinners/ClipLoader";
import dayjs from "dayjs";
import popupsuccessimg from "../assets/img/Layer 1.png";
import "../assets/css/style.css";
// import "../pages/form.css";
const BookingIntakeForm = () => {
  const navigate = useNavigate();
  const { selectedLanguage } = useContext(LanguageContext);
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const successModalRef = useRef(null);
  const prevParentValuesRef = useRef({});
  const [touchedFields, setTouchedFields] = useState({});
  const [countryCodes, setCountryCodes] = useState([]);
  const [selectedCountryCodes, setSelectedCountryCodes] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [signaturePreview, setSignaturePreview] = useState(null);
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [signatureType, setSignatureType] = useState(null);
  const [activeSection, setActiveSection] = useState(null);
  const [visitedSections, setVisitedSections] = useState(new Set());
  const canadacity = "https://prod-asra.s3.us-east-1.amazonaws.com/canada-skyline.png";

  // console.log("Stepper code loaded");
  const {
    consultation_type_id,
    listofservice_id,
    bookingdate,
    starttime,
    endtime,
    serviceHeading,
  } = location.state || {};
  const [personalinformation, setPersonalInformation] = useState("");
  const [personalInformationValues, setpersonalInformationValues] = useState(
    {},
  );

  const [signaturedocument, setSignatureDocument] = useState("");
  const [signatureName, setSignatureName] = useState(null);
  const [bagroundinformationvalues, setbagroundInformationValues] =
    useState("");

  const [personalInformationErr, setPersonalInformationErr] = useState({});

  const [isAgreed, setIsAgreed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [paymentInformationValues, setPaymentInformationValues] = useState("");

  const STORAGE_KEY = "booking_step2_data";
  const [isHydrated, setIsHydrated] = useState(false);
  const languageChangeRef = useRef(false);
  const isRestoringRef = useRef(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Helper function to get options_value for a selected option - MOVED TO COMPONENT LEVEL
  const getSelectedOptionValue = (sectionsLabelsId, selectedValue) => {
    if (!selectedValue) return null;

    let selectedOptionValue = null;

    if (Array.isArray(personalinformation)) {
      personalinformation.forEach((group) => {
        if (!Array.isArray(group.sections)) return;
        group.sections.forEach((section) => {
          if (!Array.isArray(section.data)) return;
          section.data.forEach((item) => {
            if (item.sections_labels_id === sectionsLabelsId && item.options) {
              const matchedOption = item.options.find(
                (opt) => opt.option === selectedValue,
              );
              if (matchedOption) {
                selectedOptionValue = matchedOption.options_value;
              }
            }
          });
        });
      });
    }

    return selectedOptionValue;
  };

  const getStepStatus = (section) => {
    if (isSectionCompleted(section)) return "completed";

    if (activeSection === `section-${section.sections_id}`) return "active";

    return "";
  };




  useEffect(() => {
    if (!Array.isArray(personalinformation) || personalinformation.length === 0)
      return;

    const sections = Array.from(document.querySelectorAll(".section"));
    const headerOffset = 90;
    let ticking = false;

    const updateActiveSection = () => {
      const triggerLine = headerOffset + window.innerHeight * 0.3;
      let current = sections[0]?.id;
      const passed = [];

      for (const section of sections) {
        const rect = section.getBoundingClientRect();
        if (rect.height === 0) continue; // not laid out yet, skip for now
        const top = rect.top;
        if (top <= triggerLine) {
          current = section.id;
          passed.push(section.id); // every section scrolled past, not just the current one
        } else {
          break;
        }
      }

      setActiveSection(current);

      if (passed.length > 0) {
        setVisitedSections((prev) => {
          const next = new Set(prev);
          passed.forEach((id) => next.add(id));
          return next;
        });
      }

      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateActiveSection);
        ticking = true;
      }
    };

    requestAnimationFrame(() => requestAnimationFrame(updateActiveSection));
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => window.removeEventListener("scroll", onScroll);
  }, [personalinformation]);

  // useEffect(() => {
  //   console.log("Active Section:", activeSection);
  // }, [activeSection]);

  useEffect(() => {
    const active = document.querySelector(".sidebar-steps li.active");
    const rail = document.querySelector(".sidebar-steps");

    if (active && rail) {
      const railRect = rail.getBoundingClientRect();
      const activeRect = active.getBoundingClientRect();
      const offset =
        activeRect.left -
        railRect.left -
        railRect.width / 2 +
        activeRect.width / 2;

      rail.scrollBy({ left: offset, behavior: "smooth" });
    }
  }, [activeSection]);

  //  useEffect(() => {
  //   const active = document.querySelector(".sidebar-steps li.active");
  //   const rail = document.querySelector(".sidebar-steps");

  //   if (!active || !rail) return;

  //   const isHorizontal = rail.scrollWidth > rail.clientWidth;
  //   const isVertical = rail.scrollHeight > rail.clientHeight;

  //   const railRect = rail.getBoundingClientRect();
  //   const activeRect = active.getBoundingClientRect();

  //   if (isHorizontal) {
  //     const offsetX =
  //       activeRect.left -
  //       railRect.left -
  //       railRect.width / 2 +
  //       activeRect.width / 2;
  //     rail.scrollBy({ left: offsetX, behavior: "smooth" });
  //   }

  //   if (isVertical) {
  //     const offsetY =
  //       activeRect.top -
  //       railRect.top -
  //       railRect.height / 2 +
  //       activeRect.height / 2;
  //     rail.scrollBy({ top: offsetY, behavior: "smooth" });
  //   }
  // }, [activeSection]);

  const isHireInCanada = () => {
    if (!serviceHeading) return false;

    const normalizedHeading = serviceHeading.trim().toLowerCase();
    return (
      normalizedHeading === "hire in canada" ||
      normalizedHeading === "embaucher au canada"
    );
  };
  const home = () => {
    navigate("/");
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);
  const savedStep1 = JSON.parse(sessionStorage.getItem("booking_step1_data"));

  useEffect(() => {
    sessionStorage.removeItem(STORAGE_KEY);
    setIsHydrated(true);
    isRestoringRef.current = false;

    return () => {
      sessionStorage.removeItem(STORAGE_KEY); // also clear on unmount
    };
  }, []);
  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
    });

  const BookingForm = (e) => {
    e.preventDefault();
    navigate("/bookingform");
  };
  const isSignatureField = (item) =>
    item.label?.trim().toLowerCase() === "signature";
  const handleFileChange = async (id, e, singleFile = false) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const filesToProcess = singleFile ? [files[0]] : files;

    for (const file of filesToProcess) {
      const previewUrl = URL.createObjectURL(file);
      const base64Data = await fileToBase64(file);

      const isDocument = [
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ].includes(file.type);

      const finalBase64 = isDocument ? base64Data.split(",")[1] : base64Data;

      const req = {
        name: "My Document",
        document: [{ name: file.name, type: file.type, base64: finalBase64 }],
      };

      try {
        const res = await API.post("imageUpload/add", req);
        const uploadedUrl = res.data.url?.[0];

        const newFileEntry = {
          name: file.name,
          type: file.type,
          preview: previewUrl,
          url: uploadedUrl,
        };

        setUploadedFiles((prev) => ({
          ...prev,
          [id]: singleFile
            ? [newFileEntry]
            : [...(prev[id] || []), newFileEntry],
        }));

        setpersonalInformationValues((prev) => ({
          ...prev,
          [id]: singleFile ? [uploadedUrl] : [...(prev[id] || []), uploadedUrl],
        }));

        setPersonalInformationErr((prev) => ({ ...prev, [id]: "" }));
      } catch (err) {
        console.error("Upload error:", err.response?.data || err.message);
      }
    }
  };

  const handleSignatureUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setSignatureType(file.type);
    setSignatureName(file.name);
    setSignaturePreview(URL.createObjectURL(file));
    const base64 = await fileToBase64(file);
    const req = {
      name: "Signature",
      document: [
        {
          name: file.name,
          type: file.type,
          base64: base64,
        },
      ],
    };

    try {
      const res = await API.post("imageUpload/add", req);
      const uploadedUrl = res.data.url?.[0];
      setSignatureUrl(uploadedUrl);
    } catch (err) {
      console.error("Signature upload error:", err);
    }
  };

  useEffect(() => {
    if (selectedLanguage.id) {
      formList();
    }
  }, [selectedLanguage.id, listofservice_id]);

  useEffect(() => {
    API.post("countryDropdown/webCondition", {
      language_id: selectedLanguage.id,
    })
      .then((res) => {
        if (res.data.success === true) {
          const data = res.data.data || [];
          setCountryCodes(data);

          const canada = data.find((c) => c.country_name === "Canada");
          if (canada && Array.isArray(personalinformation)) {
            const defaults = {};
            personalinformation.forEach((group) => {
              if (!Array.isArray(group.sections)) return;
              group.sections.forEach((section) => {
                if (!Array.isArray(section.data)) return;
                section.data.forEach((item) => {
                  if (mapInputType(item.input_type) === "phoneno") {
                    defaults[item.sections_labels_id] = {
                      country_id: canada.country_id,
                    };
                  }
                });
              });
            });
            setSelectedCountryCodes(defaults);
          }
        }
      })
      .catch((err) => console.error("Country codes fetch error:", err));
  }, [selectedLanguage.id, personalinformation]);

  const formList = () => {
    setLoading(true);

    const req = {
      language_id: selectedLanguage.id,
      listofservice_id: listofservice_id,
    };

    API.post("sectionsLabelList1/webCondition", req)
      .then((res) => {
        if (res.data.success === true) {
          setPersonalInformation(res.data.data || []);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("formList error:", err);
        setLoading(false);
      });
  };

  const handlePersonalInformation = (id, value, inputType) => {
    setpersonalInformationValues((prev) => ({ ...prev, [id]: value }));

    if (inputType === "email") {
      if (value && !emailRegex.test(value)) {
        setPersonalInformationErr((prev) => ({
          ...prev,
          [id]:
            selectedLanguage.id === 1
              ? "Enter a valid email"
              : "Entrez une adresse e-mail valide",
        }));
      } else {
        setPersonalInformationErr((prev) => ({ ...prev, [id]: "" }));
      }
    } else if (inputType === "phoneno") {
      if (value && !phoneRegex.test(value)) {
        setPersonalInformationErr((prev) => ({
          ...prev,
          [id]:
            selectedLanguage.id === 1
              ? "Enter valid phone number"
              : "Entrez un numéro de téléphone valide",
        }));
      } else {
        setPersonalInformationErr((prev) => ({ ...prev, [id]: "" }));
      }
    } else if (inputType === "website") {
      const websiteRegex =
        /^(https?:\/\/)?(www\.)?([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
      if (value && !websiteRegex.test(value.trim())) {
        setPersonalInformationErr((prev) => ({
          ...prev,
          [id]:
            selectedLanguage.id === 1
              ? "Please enter a valid website URL"
              : "Veuillez entrer une URL valide)",
        }));
      } else {
        setPersonalInformationErr((prev) => ({ ...prev, [id]: "" }));
      }
    } else {
      setPersonalInformationErr((prev) => ({ ...prev, [id]: "" }));
    }
  };

  useEffect(() => {
    const savedData = sessionStorage.getItem(STORAGE_KEY);

    if (savedData) {
      const parsed = JSON.parse(savedData);

      // Ensure table data has proper structure
      const formattedPersonalValues = {};
      Object.keys(parsed.personalInformationValues || {}).forEach((key) => {
        const value = parsed.personalInformationValues[key];
        if (
          Array.isArray(value) &&
          value.length > 0 &&
          typeof value[0] === "object"
        ) {
          formattedPersonalValues[key] = value;
        } else {
          formattedPersonalValues[key] = value;
        }
      });

      setpersonalInformationValues(formattedPersonalValues);
      setbagroundInformationValues(parsed.bagroundinformationvalues || {});
      setUploadedFiles(parsed.uploadedFiles || {});
      setPaymentInformationValues(parsed.paymentInformationValues || {});
      setIsAgreed(parsed.isAgreed || false);
      setSignaturePreview(parsed.signaturePreview || null);
      setSignatureType(parsed.signatureType || "");
      setSignatureName(parsed.signatureName || "");
    }

    setIsHydrated(true);
    isRestoringRef.current = false;
  }, []);

  useEffect(() => {
    if (!isHydrated) return;
    if (isRestoringRef.current) return;

    const data = {
      personalInformationValues,
      bagroundinformationvalues,
      uploadedFiles,
      paymentInformationValues,
      isAgreed,
      signaturePreview,
      signatureType,
      signatureName,
    };

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }, [
    isHydrated,
    personalInformationValues,
    bagroundinformationvalues,
    uploadedFiles,
    paymentInformationValues,
    isAgreed,
    signaturePreview,
    signatureType,
    signatureName,
  ]);
  const SubmitButton = () => {
    if (isSubmitting) {
      return;
    }

    let isValid = true;
    let errors = {};

    // VALIDATION - Using options_value
    if (Array.isArray(personalinformation)) {
      personalinformation.forEach((group) => {
        if (!Array.isArray(group.sections)) return;
        group.sections.forEach((section) => {
          if (!Array.isArray(section.data)) return;
          section.data.forEach((item) => {
            const value = personalInformationValues[item.sections_labels_id];
            const parentValue = personalInformationValues[item.dependent_on];

            // Get the options_value of the parent's selected option
            let parentOptionsValue = null;
            if (item.dependent_on && parentValue) {
              parentOptionsValue = getSelectedOptionValue(
                item.dependent_on,
                parentValue,
              );
            }

            // Determine if dependent field should be enabled based on options_value
            let isDependentEnabled = true;
            if (item.dependent_on) {
              if (!parentValue) {
                delete errors[item.sections_labels_id];
                return;
              }
              isDependentEnabled = parentOptionsValue !== "No";
            }
            if (!isDependentEnabled) {
              delete errors[item.sections_labels_id];
              return;
            }

            // Determine if field is required
            let isRequired = false;
            if (item.label_mandatory === "Yes") {
              isRequired = true;
            }

            if (isRequired && isDependentEnabled) {
              const inputType = mapInputType(item.input_type);

              if (inputType === "checkbox_declaration") {
                if (!value) {
                  isValid = false;
                  errors[item.sections_labels_id] =
                    selectedLanguage.id === 1
                      ? "* Field is mandatory"
                      : "* Le champ est obligatoire";
                }
              } else if (inputType === "table") {
                if (!Array.isArray(value) || value.length === 0) {
                  isValid = false;
                  errors[item.sections_labels_id] =
                    `${item.label.replace(/\?/g, "").trim()} ${selectedLanguage.id === 1 ? "is required" : "est requis"}`;
                } else {
                  let hasEmptyCell = false;
                  for (const row of value) {
                    if (!row || typeof row !== "object") {
                      hasEmptyCell = true;
                      break;
                    }
                    for (const colValue of Object.values(row)) {
                      if (
                        colValue === undefined ||
                        colValue === null ||
                        String(colValue).trim() === ""
                      ) {
                        hasEmptyCell = true;
                        break;
                      }
                    }
                    if (hasEmptyCell) break;
                  }
                  if (hasEmptyCell) {
                    isValid = false;
                    errors[item.sections_labels_id] =
                      selectedLanguage.id === 1
                        ? "Please fill all table fields"
                        : "Veuillez remplir tous les champs du tableau";
                  }
                }
              } else if (
                value === undefined ||
                value === null ||
                value === "" ||
                (Array.isArray(value) && value.length === 0)
              ) {
                isValid = false;
                errors[item.sections_labels_id] =
                  `${item.label.replace(/\?/g, "").trim()} ${selectedLanguage.id === 1 ? "is required" : "est requis"}`;
              } else if (
                inputType === "phoneno" &&
                !selectedCountryCodes[item.sections_labels_id]?.country_id
              ) {
                isValid = false;
                errors[item.sections_labels_id] =
                  selectedLanguage.id === 1
                    ? "Please select a country code"
                    : "Veuillez sélectionner un indicatif pays";
              } else if (
                inputType === "email" &&
                value &&
                !emailRegex.test(value)
              ) {
                isValid = false;
                errors[item.sections_labels_id] =
                  selectedLanguage.id === 1
                    ? "Enter a valid email"
                    : "Entrez une adresse e-mail valide";
              } else if (
                inputType === "phoneno" &&
                value &&
                !phoneRegex.test(value)
              ) {
                isValid = false;
                errors[item.sections_labels_id] =
                  selectedLanguage.id === 1
                    ? "Enter valid phone number"
                    : "Entrez un numéro de téléphone valide";
              } else if (inputType === "website" && value) {
                const websiteRegex =
                  /^(https?:\/\/)?(www\.)?([a-zA-Z0-9\-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;
                if (!websiteRegex.test(value.trim())) {
                  isValid = false;
                  errors[item.sections_labels_id] =
                    selectedLanguage.id === 1
                      ? "Please enter a valid website URL"
                      : "Veuillez entrer une URL valide";
                }
              }
            }
          });
        });
      });
    }

    setPersonalInformationErr(errors);

    if (!isValid) {
      const firstErrorKey = Object.keys(errors)[0];
      const errorElement = document.querySelector(
        `[data-error-id="${firstErrorKey}"]`,
      );
      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
      return;
    }

    setIsSubmitting(true);

    const getTimezone = () => {
      return Intl.DateTimeFormat().resolvedOptions().timeZone;
    };

    const form_data = [];
    if (Array.isArray(personalinformation)) {
      personalinformation.forEach((group) => {
        if (!Array.isArray(group.sections)) return;
        group.sections.forEach((section) => {
          if (!Array.isArray(section.data)) return;
          section.data.forEach((item) => {
            let value = personalInformationValues[item.sections_labels_id];
            const inputType = mapInputType(item.input_type);

            const entry = {
              sections_labels_id: item.sections_labels_id,
              details: Array.isArray(value)
                ? JSON.stringify(value)
                : typeof value === "object" && value !== null
                  ? JSON.stringify(value)
                  : value || "",
            };

            if (inputType === "phoneno") {
              entry.country_id =
                selectedCountryCodes[item.sections_labels_id]?.country_id ||
                null;
            }

            form_data.push(entry);
          });
        });
      });
    }

    const req = {
      language_id: selectedLanguage.id,
      consultation_type_id: Number(consultation_type_id),
      listofservice_id: Number(listofservice_id),
      booking_date: bookingdate || null,
      start_time: starttime || null,
      end_time: endtime || null,
      user_timezone: getTimezone(),
      form_data: form_data,
    };

    console.log("SUBMIT REQ:", req);

    API.post("UserSectionsConsultationAdd/add1", req)
      .then((res) => {
        if (res.data.success === true) {
          sessionStorage.removeItem("booking_step1_data");
          sessionStorage.removeItem("booking_step2_data");
          setShowModal(true);
          setLoading(true);
          setTimeout(() => {
            setLoading(false);
            setIsSubmitting(false);
          }, 1500);
        } else {
          setIsSubmitting(false);
        }
      })
      .catch((err) => {
        console.error("Submit error:", err);
        setIsSubmitting(false);
      });
  };
  // Clear dependent fields when parent field is set to "No"
  // Track previous parent values to only trigger when a parent actually changes

  useEffect(() => {
    if (!Array.isArray(personalinformation)) return;

    const itemMap = {};
    personalinformation.forEach((group) => {
      if (!Array.isArray(group.sections)) return;
      group.sections.forEach((section) => {
        if (!Array.isArray(section.data)) return;
        section.data.forEach((item) => {
          itemMap[item.sections_labels_id] = item;
        });
      });
    });

    const parentIds = new Set(
      Object.values(itemMap)
        .filter((item) => item.dependent_on)
        .map((item) => item.dependent_on),
    );

    let parentChanged = false;
    parentIds.forEach((parentId) => {
      const current = personalInformationValues[parentId];
      const prev = prevParentValuesRef.current[parentId];
      if (current !== prev) {
        parentChanged = true;
      }
    });

    // Save OLD parent values before updating the ref
    const oldParentValues = { ...prevParentValuesRef.current };

    const newParentValues = {};
    parentIds.forEach((id) => {
      newParentValues[id] = personalInformationValues[id];
    });
    prevParentValuesRef.current = newParentValues;

    if (!parentChanged) return;

    const updatedValues = { ...personalInformationValues };
    const updatedErrors = { ...personalInformationErr };
    let hasChanges = false;

    const clearFieldAndDescendants = (sectionsLabelsId) => {
      const item = itemMap[sectionsLabelsId];
      if (!item) return;

      const inputType = mapInputType(item.input_type);
      const currentValue = updatedValues[sectionsLabelsId];

      if (inputType === "table") {
        const parentItem = itemMap[item.dependent_on];
        const parentInputType = parentItem
          ? mapInputType(parentItem.input_type)
          : null;

        if (parentInputType === "radio_button") {
          if (Array.isArray(currentValue) && currentValue.length > 0) {
            updatedValues[sectionsLabelsId] = currentValue.map((row) => {
              const clearedRow = {};
              Object.keys(row).forEach((col) => {
                clearedRow[col] = "";
              });
              return clearedRow;
            });
            updatedErrors[sectionsLabelsId] = "";
            hasChanges = true;
          }
        }
      } else {
        const emptyValue =
          inputType === "checkbox"
            ? []
            : inputType === "checkbox_declaration"
              ? false
              : "";

        const isEmpty =
          currentValue === undefined ||
          currentValue === null ||
          currentValue === "" ||
          currentValue === false ||
          (Array.isArray(currentValue) && currentValue.length === 0);

        if (!isEmpty) {
          updatedValues[sectionsLabelsId] = emptyValue;
          updatedErrors[sectionsLabelsId] = "";
          hasChanges = true;
        }
      }

      Object.values(itemMap).forEach((child) => {
        if (child.dependent_on === sectionsLabelsId) {
          clearFieldAndDescendants(child.sections_labels_id);
        }
      });
    };

    // Clear disabled fields and their descendants
    Object.values(itemMap).forEach((item) => {
      if (!item.dependent_on) return;
      const parentRaw = personalInformationValues[item.dependent_on];
      const parentOptionsValue = getSelectedOptionValue(
        item.dependent_on,
        parentRaw,
      );
      const isDisabled = parentOptionsValue === "No";

      if (isDisabled) {
        clearFieldAndDescendants(item.sections_labels_id);
      }
    });

    // Clear table fields whenever their radio parent value changes
    Object.values(itemMap).forEach((item) => {
      if (!item.dependent_on) return;
      const inputType = mapInputType(item.input_type);
      if (inputType !== "table") return;

      const parentItem = itemMap[item.dependent_on];
      if (!parentItem) return;
      const parentInputType = mapInputType(parentItem.input_type);
      if (parentInputType !== "radio_button") return;

      const currentParentVal = personalInformationValues[item.dependent_on];
      const prevParentVal = oldParentValues[item.dependent_on];
      if (currentParentVal === prevParentVal) return;

      // Don't clear on first click — only clear when changing from a previously selected value
      if (
        prevParentVal === undefined ||
        prevParentVal === null ||
        prevParentVal === ""
      )
        return;

      const currentValue = updatedValues[item.sections_labels_id];
      if (Array.isArray(currentValue) && currentValue.length > 0) {
        const hasFilledCell = currentValue.some(
          (row) =>
            row &&
            typeof row === "object" &&
            Object.values(row).some(
              (v) => v !== "" && v !== null && v !== undefined,
            ),
        );
        if (hasFilledCell) {
          updatedValues[item.sections_labels_id] = currentValue.map((row) => {
            const clearedRow = {};
            Object.keys(row).forEach((col) => {
              clearedRow[col] = "";
            });
            return clearedRow;
          });
          updatedErrors[item.sections_labels_id] = "";
          hasChanges = true;
        }
      }
    });

    if (hasChanges) {
      setpersonalInformationValues(updatedValues);
      setPersonalInformationErr(updatedErrors);

      setUploadedFiles((prev) => {
        const updated = { ...prev };
        Object.keys(updatedValues).forEach((key) => {
          const val = updatedValues[key];
          const wasCleared =
            val === "" ||
            val === false ||
            (Array.isArray(val) && val.length === 0);
          if (wasCleared && prev[key]) {
            delete updated[key];
          }
        });
        return updated;
      });
    }
  }, [personalInformationValues, personalinformation]);

  useEffect(() => {
    if (!Array.isArray(personalinformation)) return;
    if (Object.keys(personalInformationErr).length === 0) return;

    const updatedErrors = { ...personalInformationErr };
    let hasChanges = false;

    const checkAndClearErrors = () => {
      personalinformation.forEach((group) => {
        if (!Array.isArray(group.sections)) return;
        group.sections.forEach((section) => {
          if (!Array.isArray(section.data)) return;
          section.data.forEach((item) => {
            // Check if this field has a dependency
            if (item.dependent_on) {
              const parentValue = personalInformationValues[item.dependent_on];
              const parentOptionsValue = getSelectedOptionValue(
                item.dependent_on,
                parentValue,
              );
              const isDisabled = parentOptionsValue === "No";

              // If field is disabled and has an error, clear it immediately
              if (isDisabled && updatedErrors[item.sections_labels_id]) {
                console.log(
                  `Clearing error for disabled field: ${item.sections_labels_id}`,
                );
                updatedErrors[item.sections_labels_id] = "";
                hasChanges = true;
              }
            }
          });
        });
      });
    };

    checkAndClearErrors();

    if (hasChanges) {
      setPersonalInformationErr(updatedErrors);
    }
  }, [personalInformationValues, personalinformation]);

  useEffect(() => {
    if (!personalinformation || !Array.isArray(personalinformation)) return;

    const initialValues = { ...personalInformationValues };
    let hasChanges = false;

    personalinformation.forEach((group) => {
      if (!Array.isArray(group.sections)) return;

      group.sections.forEach((section) => {
        if (!Array.isArray(section.data)) return;

        section.data.forEach((item) => {
          const inputType = mapInputType(item.input_type);

          if (inputType === "table") {
            const existingValue =
              personalInformationValues[item.sections_labels_id];
            const requiredRows = isHireInCanada()
              ? 1
              : item.sections_input_row || 1;
            if (
              !existingValue ||
              (Array.isArray(existingValue) &&
                existingValue.length !== requiredRows)
            ) {
              const newRows = [];
              for (let i = 0; i < requiredRows; i++) {
                const newRow = {};
                item.options.forEach((opt) => {
                  newRow[opt.option] = "";
                });
                newRows.push(newRow);
              }

              initialValues[item.sections_labels_id] = newRows;
              hasChanges = true;
            }
          }
        });
      });
    });

    if (hasChanges) {
      setpersonalInformationValues(initialValues);
    }
  }, [personalinformation, serviceHeading]);

  const backButton = () => {
    navigate("/bookingform", { state: { fromStep2: true } });
  };

  const handleTableChange = (sectionLabelId, rowIndex, columnName, value) => {
    setpersonalInformationValues((prev) => {
      const existingTable = prev[sectionLabelId] || [];

      const updatedTable = [...existingTable];

      if (!updatedTable[rowIndex]) {
        updatedTable[rowIndex] = {};
      }

      updatedTable[rowIndex][columnName] = value;

      return {
        ...prev,
        [sectionLabelId]: updatedTable,
      };
    });

    setPersonalInformationErr((prev) => ({
      ...prev,
      [sectionLabelId]: "",
    }));
  };

  const mapInputType = (type) => {
    const lowerType = type?.toLowerCase() || "";

    if (
      lowerType === "date" ||
      lowerType === "previous date" ||
      lowerType === "future date" ||
      lowerType === "date précédente" ||
      lowerType === "date future"
    ) {
      return "date";
    }

    switch (lowerType) {
      case "text":
      case "texte":
        return "text";
      case "website":
      case "site web":
        return "website";
      case "numbers":
      case "nombres":
        return "number";
      case "text with numbers":
      case "texte avec des chiffres":
        return "mixed";
      case "radio_button":
      case "bouton_radio":
        return "radio_button";
      case "drop_down":
      case "dérouler":
        return "drop_down";
      case "checkbox":
      case "case à cocher":
        return "checkbox";
      case "briefly_description":
      case "brièvement_description":
        return "textarea";
      case "email":
      case "e-mail":
        return "email";
      case "phoneno":
      case "numéro de téléphone":
        return "phoneno";
      case "checkbox declaration":
      case "déclaration de case à cocher":
        return "checkbox_declaration";
      case "table":
      case "tableau":
        return "table";
      case "image":
      case "image":
        return "image";
      default:
        return "input";
    }
  };

  const emailRegex = /^[^\s@]+@[^\s@]+(\.[a-zA-Z]{2,})+$/;

  const phoneRegex = /^\d{6,12}$/;

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getDateRestriction = (inputType) => {
    const type = inputType?.toLowerCase();

    // English Previous Date
    if (type === "previous date") {
      return "previous";
    }

    // English Future Date
    if (type === "future date") {
      return "future";
    }

    // French Previous Date
    if (type === "date précédente") {
      return "previous";
    }

    // French Future Date
    if (type === "date future") {
      return "future";
    }

    return "none";
  };

  const getDateErrorMessage = (restriction, selectedLanguage) => {
    if (restriction === "previous") {
      return selectedLanguage.id === 1
        ? "Date cannot be in the future"
        : "La date ne peut pas être dans le futur";
    }
    if (restriction === "future") {
      return selectedLanguage.id === 1
        ? "Date cannot be in the past"
        : "La date ne peut pas être dans le passé";
    }
    return "";
  };

  const isSectionCompleted = (section) => {

    const sectionId = `section-${section.sections_id}`;


    if (!visitedSections.has(sectionId)) {
      return false;
    }


    return section.data.every((field) => {
      if (field.label_mandatory !== "Yes") {
        return true;
      }

      const parentRaw = personalInformationValues[field.dependent_on];

      let parentOptionsValue = null;

      if (field.dependent_on && parentRaw) {
        parentOptionsValue = getSelectedOptionValue(
          field.dependent_on,
          parentRaw,
        );
      }

      const isDisabled = field.dependent_on && parentOptionsValue === "No";

      if (isDisabled) {
        return true;
      }

      const value = personalInformationValues[field.sections_labels_id];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === "boolean") {
        return value;
      }

      return (
        value !== undefined && value !== null && String(value).trim() !== ""
      );
    });
  };

  return (
    <div>
      {loading ? (
        <div
          className="d-flex justify-content-center mt-5 align-items-center p-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <>
          <div>
            <div class="container px-3">
              <section class="faq-hero container p-4 p-lg-5 rounded-5">
                {selectedLanguage.id === 1 ? (
                  <h1>Book a Consultation</h1>
                ) : (
                  <h1>Réserver une consultation</h1>
                )}
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                      <a onClick={home} style={{ cursor: "pointer" }}>
                        {selectedLanguage.id === 1 ? "Home" : "Accueil"}
                      </a>
                    </li>
                    <li class="breadcrumb-item">
                      <a onClick={BookingForm} style={{ cursor: "pointer" }}>
                        {selectedLanguage.id === 1
                          ? "Book a Consultation"
                          : "Réserver une consultation"}
                      </a>
                    </li>
                    {serviceHeading && (
                      <li class="breadcrumb-item active">{serviceHeading}</li>
                    )}
                  </ol>
                </nav>
              </section>
            </div>

            <div className="container">
              <button
                className="btn mb-3 backconsultation"
                onClick={backButton}
              >
                {selectedLanguage.id === 1 ? "← Back" : "← Retour"}
              </button>

              <div className="intake-shell">
                <aside className="intake-sidebar"

                  style={{
                    backgroundImage: `url(${canadacity})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "bottom center",
                    backgroundSize: "100% auto",
                  }}
                >
                  <div className="sidebar-head">
                    <span className="eyebrow">
                      {selectedLanguage.id === 1
                        ? "Application progress"
                        : "Progression"}
                    </span>
                  </div>
                  <ul className="sidebar-steps">
                    {personalinformation
                      ?.flatMap((group) => group.sections || [])
                      .map((section, index) => {
                        const status = getStepStatus(section);
                        return (
                          <li
                            key={section.sections_id}
                            className={status}
                            onClick={() => {
                              const element = document.getElementById(
                                `section-${section.sections_id}`,
                              );

                              if (element) {
                                const stickyOffset = 90;
                                const targetY =
                                  element.getBoundingClientRect().top +
                                  window.pageYOffset -
                                  stickyOffset;

                                window.scrollTo({
                                  top: targetY,
                                  behavior: "smooth",
                                });
                                setActiveSection(
                                  `section-${section.sections_id}`,
                                );
                              }
                            }}
                          >
                            <span className="dot">
                              {status === "completed" ? "✓" : index + 1}
                            </span>
                            <span className="label">
                              {section.sections_titles &&
                                section.sections_titles.trim() !== ""
                                ? section.sections_titles
                                : "Declaration"}
                            </span>
                          </li>
                        );
                      })}
                  </ul>
                </aside>

                <div class="container pt-1 pb-5 ">
                  <div class="form-wrapper mx-auto p-2 p-md-4">
                    <div className="Fields-heading">
                      <h2 class="form-title text-start">
                        {selectedLanguage.id === 1
                          ? "IMMIGRATION CONSULTATION INTAKE FORM"
                          : "FORMULAIRE D'INSCRIPTION À LA CONSULTATION D'IMMIGRATION"}
                      </h2>
                      <p>
                        {selectedLanguage.id === 1
                          ? "fields marked with * are mandatory."
                          : "les champs marqués * sont obligatoires."}
                      </p>
                    </div>
                    {Array.isArray(personalinformation) &&
                      personalinformation.length > 0 &&
                      personalinformation[0]?.service_heading && (
                        <div className="form-service-heading mb-4">
                          {personalinformation[0].service_heading}
                        </div>
                      )}
                    {Array.isArray(personalinformation) &&
                      personalinformation.map(
                        (group) =>
                          Array.isArray(group.sections) &&
                          group.sections.map((section) => (
                            <div
                              key={section.sections_id}
                              id={`section-${section.sections_id}`}
                              className="section mb-4"
                            >
                              {Array.isArray(section.data) &&
                                !section.data.every(
                                  (item) =>
                                    mapInputType(item.input_type) ===
                                    "checkbox_declaration",
                                ) && (
                                  <h5 className="form-heading mb-4">
                                    {section.sections_titles} :
                                  </h5>
                                )}
                              <div
                                className="form-section-heading fw-bold mb-4"
                                dangerouslySetInnerHTML={{
                                  __html: section.section_heading,
                                }}
                              />
                              <div className="row gx-5 gy-1">
                                {Array.isArray(section.data) &&
                                  section.data.map((item) => {
                                    const inputType = mapInputType(
                                      item.input_type,
                                    );
                                    const value =
                                      inputType === "table"
                                        ? personalInformationValues[
                                        item.sections_labels_id
                                        ] || []
                                        : personalInformationValues[
                                        item.sections_labels_id
                                        ] || "";

                                    // NEW isDisabled logic using options_value
                                    const parentRaw =
                                      personalInformationValues[
                                      item.dependent_on
                                      ];
                                    let parentOptionsValue = null;
                                    if (item.dependent_on && parentRaw) {
                                      parentOptionsValue =
                                        getSelectedOptionValue(
                                          item.dependent_on,
                                          parentRaw,
                                        );
                                    }

                                    let isDisabled = false;
                                    if (item.dependent_on) {
                                      isDisabled = parentOptionsValue === "No";
                                    }

                                    const columnClass = [
                                      "column-2",
                                      "colonne-2",
                                    ].includes(item.columns_value)
                                      ? "col-md-6"
                                      : ["column-1", "colonne-1"].includes(
                                        item.columns_value,
                                      ) &&
                                        ["table", "tableau"].includes(
                                          item.input_type?.toLowerCase(),
                                        )
                                        ? "col-md-10"
                                        : ["column-1", "colonne-1"].includes(
                                          item.columns_value,
                                        ) &&
                                          [
                                            "phoneno",
                                            "numéro de téléphone",
                                            "text",
                                            "texte",
                                            "website",
                                            "site web",
                                            "numbers",
                                            "nombres",
                                            "briefly_description",
                                            "brièvement_description",
                                          ].includes(
                                            item.input_type?.toLowerCase(),
                                          )
                                          ? "col-md-6"
                                          : ["column-1", "colonne-1"].includes(
                                            item.columns_value,
                                          ) &&
                                            [
                                              "input_field",
                                              "text",
                                              "texte",
                                              "website",
                                              "site web",
                                              "numbers",
                                              "nombres",
                                              "text with numbers",
                                              "texte avec des chiffres",
                                              "champ_entrée",
                                              "drop_down",
                                              "dérouler",
                                              "briefly_description",
                                              "brièvement_description",
                                            ].includes(item.input_type)
                                            ? "col-md-6"
                                            : "col-md-12";

                                    return (
                                      <div
                                        key={item.sections_labels_id}
                                        data-error-id={item.sections_labels_id}
                                        className={`mb-3 ${columnClass}`}
                                      >
                                        {inputType !==
                                          "checkbox_declaration" && (
                                            <label className="mb-2 labelinput">
                                              {item.label}
                                              {item.label_mandatory === "Yes" &&
                                                inputType !==
                                                "checkbox_declaration" &&
                                                !isDisabled && (
                                                  <span className="text-danger">
                                                    {" "}
                                                    *
                                                  </span>
                                                )}
                                            </label>
                                          )}

                                        {/* TABLE FIELD */}
                                        {inputType === "table" && (
                                          <div className="table-responsive">
                                            <table
                                              className="table table-bordered text-center align-middle"
                                              style={{
                                                borderCollapse: "collapse",

                                                opacity: isDisabled ? 0.6 : 1,
                                                pointerEvents: isDisabled
                                                  ? "none"
                                                  : "auto",
                                              }}
                                            >
                                              <thead>
                                                <tr>
                                                  {item.options.map((opt) => (
                                                    <th
                                                      key={
                                                        opt.sections_options_id
                                                      }
                                                      style={{
                                                        background: "#2f4363",
                                                        color: "#fff",
                                                        fontSize: "14px",
                                                        padding: "10px",
                                                      }}
                                                    >
                                                      {opt.option}
                                                    </th>
                                                  ))}

                                                  {isHireInCanada() && (
                                                    <th
                                                      style={{
                                                        background: "#2f4363",
                                                        color: "#fff",
                                                        fontSize: "14px",
                                                        padding: "10px",
                                                        width: "60px",
                                                      }}
                                                    >
                                                      Action
                                                    </th>
                                                  )}
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {(
                                                  personalInformationValues[
                                                  item.sections_labels_id
                                                  ] || []
                                                ).map((rowData, rowIndex) => (
                                                  <tr key={rowIndex}>
                                                    {item.options.map((opt) => {
                                                      const cellValue =
                                                        rowData[opt.option] ||
                                                        "";

                                                      return (
                                                        <td
                                                          key={
                                                            opt.sections_options_id
                                                          }
                                                        >
                                                          <input
                                                            type={
                                                              isHireInCanada()
                                                                ? "text"
                                                                : "number"
                                                            }
                                                            className="form-control"
                                                            value={cellValue}
                                                            placeholder={
                                                              isHireInCanada()
                                                                ? opt.option
                                                                : ""
                                                            }
                                                            min={
                                                              isHireInCanada()
                                                                ? undefined
                                                                : 0
                                                            }
                                                            max={
                                                              isHireInCanada()
                                                                ? undefined
                                                                : 9.0
                                                            }
                                                            step={
                                                              isHireInCanada()
                                                                ? undefined
                                                                : 0.01
                                                            }
                                                            disabled={
                                                              isDisabled
                                                            }
                                                            style={{
                                                              textAlign:
                                                                "center",
                                                              backgroundColor:
                                                                isDisabled
                                                                  ? "#e9ecef"
                                                                  : "white",
                                                              cursor: isDisabled
                                                                ? "not-allowed"
                                                                : "text",
                                                            }}
                                                            onChange={(e) => {
                                                              const value =
                                                                e.target.value;

                                                              if (
                                                                isHireInCanada()
                                                              ) {
                                                                // allow only letters
                                                                if (
                                                                  /^[A-Za-z ]*$/.test(
                                                                    value,
                                                                  )
                                                                ) {
                                                                  handleTableChange(
                                                                    item.sections_labels_id,
                                                                    rowIndex,
                                                                    opt.option,
                                                                    value,
                                                                  );
                                                                }
                                                              } else {
                                                                // allow numbers < 10
                                                                if (
                                                                  value ===
                                                                  "" ||
                                                                  parseFloat(
                                                                    value,
                                                                  ) < 10
                                                                ) {
                                                                  handleTableChange(
                                                                    item.sections_labels_id,
                                                                    rowIndex,
                                                                    opt.option,
                                                                    value,
                                                                  );
                                                                }
                                                              }
                                                            }}
                                                          />
                                                        </td>
                                                      );
                                                    })}

                                                    {isHireInCanada() && (
                                                      <td>
                                                        <button
                                                          type="button"
                                                          className="btn btn-sm btn-danger"
                                                          disabled={
                                                            isDisabled ||
                                                            (
                                                              personalInformationValues[
                                                              item
                                                                .sections_labels_id
                                                              ] || []
                                                            ).length <= 1
                                                          }
                                                          onClick={() => {
                                                            const existing =
                                                              personalInformationValues[
                                                              item
                                                                .sections_labels_id
                                                              ] || [];
                                                            if (
                                                              existing.length <=
                                                              1
                                                            )
                                                              return;
                                                            const updatedTable =
                                                              existing.filter(
                                                                (_, i) =>
                                                                  i !==
                                                                  rowIndex,
                                                              );
                                                            setpersonalInformationValues(
                                                              (prev) => ({
                                                                ...prev,
                                                                [item.sections_labels_id]:
                                                                  updatedTable,
                                                              }),
                                                            );
                                                          }}
                                                          title="Remove row"
                                                        >
                                                          ✕
                                                        </button>
                                                      </td>
                                                    )}
                                                  </tr>
                                                ))}
                                              </tbody>
                                            </table>

                                            {isHireInCanada() && (
                                              <div className="mt-3">
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-success"
                                                  disabled={isDisabled}
                                                  onClick={() => {
                                                    const existing =
                                                      personalInformationValues[
                                                      item.sections_labels_id
                                                      ] || [];

                                                    const newRow = {};
                                                    item.options.forEach(
                                                      (opt) => {
                                                        newRow[opt.option] = "";
                                                      },
                                                    );
                                                    setpersonalInformationValues(
                                                      (prev) => ({
                                                        ...prev,
                                                        [item.sections_labels_id]:
                                                          [...existing, newRow],
                                                      }),
                                                    );
                                                  }}
                                                >
                                                  + Add Row
                                                </button>
                                              </div>
                                            )}

                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </div>
                                        )}

                                        {/* INPUT type text FIELD */}
                                        {inputType === "text" && (
                                          <>
                                            <input
                                              type="text"
                                              className={`form-control ${isDisabled ? "disabled-field" : ""}`}
                                              style={{
                                                backgroundColor: isDisabled
                                                  ? "#e9ecef"
                                                  : "white",
                                                cursor: isDisabled
                                                  ? "not-allowed"
                                                  : "text",
                                              }}
                                              placeholder={item.placeholder}
                                              disabled={isDisabled}
                                              value={value}
                                              onKeyDown={(e) => {
                                                const allowedKeys = [
                                                  "Backspace",
                                                  "Delete",
                                                  "Tab",
                                                  "Enter",
                                                  "Escape",
                                                  "ArrowLeft",
                                                  "ArrowRight",
                                                  "ArrowUp",
                                                  "ArrowDown",
                                                  "Home",
                                                  "End",
                                                ];
                                                const isLetter =
                                                  /^[a-zA-Z]$/.test(e.key);
                                                const isSpace = e.key === " ";
                                                const isAllowedKey =
                                                  allowedKeys.includes(e.key);
                                                const isCtrlCmd =
                                                  e.ctrlKey || e.metaKey; // allow copy/paste/select all

                                                if (
                                                  !isLetter &&
                                                  !isSpace &&
                                                  !isAllowedKey &&
                                                  !isCtrlCmd
                                                ) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onChange={(e) =>
                                                handlePersonalInformation(
                                                  item.sections_labels_id,
                                                  e.target.value,
                                                )
                                              }
                                            />
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}

                                        {/* INPUT type WEBSITE FIELD */}
                                        {inputType === "website" && (
                                          <>
                                            <input
                                              type="text"
                                              className={`form-control ${isDisabled ? "disabled-field" : ""}`}
                                              style={{
                                                backgroundColor: isDisabled
                                                  ? "#e9ecef"
                                                  : "white",
                                                cursor: isDisabled
                                                  ? "not-allowed"
                                                  : "text",
                                              }}
                                              placeholder={item.placeholder}
                                              disabled={isDisabled}
                                              value={value}
                                              onKeyDown={(e) => {
                                                const allowedKeys = [
                                                  "Backspace",
                                                  "Delete",
                                                  "Tab",
                                                  "Enter",
                                                  "Escape",
                                                  "ArrowLeft",
                                                  "ArrowRight",
                                                  "ArrowUp",
                                                  "ArrowDown",
                                                  "Home",
                                                  "End",
                                                ];
                                                const isCtrlCmd =
                                                  e.ctrlKey || e.metaKey;
                                                const isValidChar =
                                                  /^[a-zA-Z0-9\-._~:/?#[\]@!$&'()*+,;=%]$/.test(
                                                    e.key,
                                                  );
                                                const isAllowedKey =
                                                  allowedKeys.includes(e.key);

                                                if (
                                                  !isValidChar &&
                                                  !isAllowedKey &&
                                                  !isCtrlCmd
                                                ) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onChange={(e) =>
                                                handlePersonalInformation(
                                                  item.sections_labels_id,
                                                  e.target.value,
                                                  "website",
                                                )
                                              }
                                            />
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}

                                        {/* INPUT type mixed FIELD */}
                                        {inputType === "mixed" && (
                                          <>
                                            <input
                                              type="text"
                                              className={`form-control ${isDisabled ? "disabled-field" : ""}`}
                                              style={{
                                                backgroundColor: isDisabled
                                                  ? "#e9ecef"
                                                  : "white",
                                                cursor: isDisabled
                                                  ? "not-allowed"
                                                  : "text",
                                              }}
                                              placeholder={item.placeholder}
                                              disabled={isDisabled}
                                              value={value}
                                              onKeyDown={(e) => {
                                                const allowedKeys = [
                                                  "Backspace",
                                                  "Delete",
                                                  "Tab",
                                                  "Enter",
                                                  "Escape",
                                                  "ArrowLeft",
                                                  "ArrowRight",
                                                  "ArrowUp",
                                                  "ArrowDown",
                                                  "Home",
                                                  "End",
                                                ];
                                                const isLetter =
                                                  /^[a-zA-Z]$/.test(e.key);
                                                const isNumber = /^[0-9]$/.test(
                                                  e.key,
                                                );
                                                const isDollar = /^\$$/.test(
                                                  e.key,
                                                );
                                                const isSlash = /^\/$/.test(
                                                  e.key,
                                                );
                                                const isSpace = e.key === " ";
                                                const isHyphen = e.key === "-";
                                                const isComma = e.key === ",";
                                                const isAllowedKey =
                                                  allowedKeys.includes(e.key);
                                                const isCtrlCmd =
                                                  e.ctrlKey || e.metaKey; // allow copy/paste/select all

                                                if (
                                                  !isLetter &&
                                                  !isDollar &&
                                                  !isSlash &&
                                                  !isNumber &&
                                                  !isSpace &&
                                                  !isHyphen &&
                                                  !isComma &&
                                                  !isAllowedKey &&
                                                  !isCtrlCmd
                                                ) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onChange={(e) =>
                                                handlePersonalInformation(
                                                  item.sections_labels_id,
                                                  e.target.value,
                                                )
                                              }
                                            />

                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}

                                        {/* INPUT type number FIELD */}
                                        {inputType === "number" && (
                                          <>
                                            <input
                                              type="text"
                                              className={`form-control ${isDisabled ? "disabled-field" : ""}`}
                                              style={{
                                                backgroundColor: isDisabled
                                                  ? "#e9ecef"
                                                  : "white",
                                                cursor: isDisabled
                                                  ? "not-allowed"
                                                  : "text",
                                              }}
                                              placeholder={item.placeholder}
                                              disabled={isDisabled}
                                              value={value}
                                              onKeyDown={(e) => {
                                                const allowedKeys = [
                                                  "Backspace",
                                                  "Delete",
                                                  "Tab",
                                                  "Enter",
                                                  "Escape",
                                                  "ArrowLeft",
                                                  "ArrowRight",
                                                  "ArrowUp",
                                                  "ArrowDown",
                                                  "Home",
                                                  "End",
                                                ];

                                                const isNumber = /^[0-9]$/.test(
                                                  e.key,
                                                );
                                                const isSpace = e.key === " ";
                                                const isAllowedKey =
                                                  allowedKeys.includes(e.key);
                                                const isCtrlCmd =
                                                  e.ctrlKey || e.metaKey; // allow copy/paste/select all

                                                if (
                                                  !isNumber &&
                                                  !isSpace &&
                                                  !isAllowedKey &&
                                                  !isCtrlCmd
                                                ) {
                                                  e.preventDefault();
                                                }
                                              }}
                                              onChange={(e) =>
                                                handlePersonalInformation(
                                                  item.sections_labels_id,
                                                  e.target.value,
                                                )
                                              }
                                            />
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}

                                        {/* DATE FIELD */}
                                        {inputType === "date" && (
                                          <>
                                            <input
                                              type="date"
                                              id={`date-${item.sections_labels_id}`}
                                              disabled={isDisabled}
                                              className={`form-control ${isDisabled ? "disabled-field" : ""}`}
                                              placeholder={item.placeholder}
                                              value={value}
                                              onChange={(e) => {
                                                const raw = e.target.value;
                                                let selectedDate = raw;

                                                // ✅ Prevent year from exceeding 4 digits
                                                if (raw) {
                                                  const parts = raw.split("-");
                                                  if (
                                                    parts[0] &&
                                                    parts[0].length > 4
                                                  ) {
                                                    parts[0] = parts[0].slice(
                                                      0,
                                                      4,
                                                    );
                                                    selectedDate =
                                                      parts.join("-");
                                                  }
                                                }
                                                // ✅ Always update the field value first — never block typing
                                                handlePersonalInformation(
                                                  item.sections_labels_id,
                                                  selectedDate,
                                                );

                                                // ✅ Only validate when date is fully entered (YYYY-MM-DD = 10 chars)
                                                if (
                                                  !selectedDate ||
                                                  selectedDate.length < 10
                                                ) {
                                                  setPersonalInformationErr(
                                                    (prev) => ({
                                                      ...prev,
                                                      [item.sections_labels_id]:
                                                        "",
                                                    }),
                                                  );
                                                  return;
                                                }

                                                const todayDate =
                                                  getTodayDate();
                                                const inputTypeValue =
                                                  item.input_type?.toLowerCase();

                                                let errorMsg = "";

                                                if (
                                                  inputTypeValue ===
                                                  "previous date" ||
                                                  inputTypeValue ===
                                                  "date précédente"
                                                ) {
                                                  if (
                                                    selectedDate > todayDate
                                                  ) {
                                                    errorMsg =
                                                      selectedLanguage.id === 1
                                                        ? "Date cannot be in the future"
                                                        : "La date ne peut pas être dans le futur";
                                                  }
                                                } else if (
                                                  inputTypeValue ===
                                                  "future date" ||
                                                  inputTypeValue ===
                                                  "date future"
                                                ) {
                                                  if (
                                                    selectedDate < todayDate
                                                  ) {
                                                    errorMsg =
                                                      selectedLanguage.id === 1
                                                        ? "Date cannot be in the past"
                                                        : "La date ne peut pas être dans le passé";
                                                  }
                                                }

                                                setPersonalInformationErr(
                                                  (prev) => ({
                                                    ...prev,
                                                    [item.sections_labels_id]:
                                                      errorMsg,
                                                  }),
                                                );
                                              }}
                                              style={{
                                                cursor: isDisabled
                                                  ? "not-allowed"
                                                  : "pointer",
                                                backgroundColor: isDisabled
                                                  ? "#e9ecef"
                                                  : "white",
                                              }}
                                              max={
                                                item.input_type?.toLowerCase() ===
                                                  "previous date" ||
                                                  item.input_type?.toLowerCase() ===
                                                  "date précédente"
                                                  ? getTodayDate()
                                                  : undefined
                                              }
                                              min={
                                                item.input_type?.toLowerCase() ===
                                                  "future date" ||
                                                  item.input_type?.toLowerCase() ===
                                                  "date future"
                                                  ? getTodayDate()
                                                  : undefined
                                              }
                                            />
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}
                                        {/* RADIO BUTTON */}
                                        {inputType === "radio_button" && (
                                          <>
                                            <div
                                              className="d-flex flex-wrap gap-3"
                                              style={{
                                                pointerEvents: isDisabled
                                                  ? "none"
                                                  : "auto",
                                                opacity: isDisabled ? 0.6 : 1,
                                              }}
                                            >
                                              {item.options.map((opt) => (
                                                <div
                                                  key={opt.sections_options_id}
                                                  className="form-check"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => {
                                                    if (!isDisabled) {
                                                      handlePersonalInformation(
                                                        item.sections_labels_id,
                                                        opt.option,
                                                      );
                                                    }
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    style={{
                                                      marginRight: "6px",
                                                      cursor: "pointer",
                                                    }}
                                                    name={`radio-${item.dependent_on || item.sections_labels_id}`}
                                                    value={opt.option}
                                                    checked={
                                                      value === opt.option
                                                    }
                                                    onChange={() => { }}
                                                    readOnly
                                                  />
                                                  <label
                                                    className="form-check-label"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    {opt.option}
                                                  </label>
                                                </div>
                                              ))}
                                            </div>
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}
                                        {/* DROPDOWN */}
                                        {inputType === "drop_down" && (
                                          <>
                                            <select
                                              className={`form-select ${isDisabled ? "disabled-field" : ""}`}
                                              value={value}
                                              disabled={isDisabled}
                                              style={{
                                                backgroundColor: isDisabled
                                                  ? "#e9ecef"
                                                  : "",
                                              }}
                                              onChange={(e) =>
                                                handlePersonalInformation(
                                                  item.sections_labels_id,
                                                  e.target.value,
                                                )
                                              }
                                            >
                                              <option value="">
                                                {selectedLanguage.id === 1
                                                  ? "Select"
                                                  : "Sélectionner"}
                                              </option>
                                              {item.options.map((opt) => (
                                                <option
                                                  key={opt.sections_options_id}
                                                  value={opt.option}
                                                >
                                                  {opt.option}
                                                </option>
                                              ))}
                                            </select>
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}

                                        {/* CHECKBOX */}
                                        {inputType === "checkbox" && (
                                          <>
                                            <div
                                              className="d-flex flex-wrap gap-3"
                                              style={{
                                                pointerEvents: isDisabled
                                                  ? "none"
                                                  : "auto",
                                                opacity: isDisabled ? 0.6 : 1,
                                              }}
                                            >
                                              {item.options.map((opt) => {
                                                const selectedValues =
                                                  value || [];
                                                const isChecked =
                                                  selectedValues.includes(
                                                    opt.option,
                                                  );

                                                return (
                                                  <div
                                                    key={
                                                      opt.sections_options_id
                                                    }
                                                    className="form-check"
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() => {
                                                      if (!isDisabled) {
                                                        let updated = [
                                                          ...selectedValues,
                                                        ];
                                                        if (!isChecked) {
                                                          updated.push(
                                                            opt.option,
                                                          );
                                                        } else {
                                                          updated =
                                                            updated.filter(
                                                              (v) =>
                                                                v !==
                                                                opt.option,
                                                            );
                                                        }
                                                        handlePersonalInformation(
                                                          item.sections_labels_id,
                                                          updated,
                                                        );
                                                      }
                                                    }}
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      className="form-check-input"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      value={opt.option}
                                                      checked={isChecked}
                                                      disabled={isDisabled}
                                                      onChange={() => { }}
                                                      readOnly
                                                    />
                                                    <label
                                                      className="form-check-label"
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      {opt.option}
                                                    </label>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}

                                        {/* TEXTAREA */}
                                        {inputType === "textarea" && (
                                          <>
                                            <textarea
                                              className={`textarea-control ${isDisabled ? "disabled-field" : ""}`}
                                              rows={5}
                                              placeholder={item.placeholder}
                                              value={value}
                                              disabled={isDisabled}
                                              style={{
                                                backgroundColor: isDisabled
                                                  ? "#e9ecef"
                                                  : "",
                                              }}
                                              onChange={(e) =>
                                                handlePersonalInformation(
                                                  item.sections_labels_id,
                                                  e.target.value,
                                                )
                                              }
                                            />
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}

                                        {/* EMAIL FIELD */}
                                        {inputType === "email" && (
                                          <>
                                            <input
                                              type="email"
                                              className={`form-control ${isDisabled ? "disabled-field" : ""}`}
                                              placeholder={item.placeholder}
                                              disabled={isDisabled}
                                              value={value}
                                              onChange={(e) =>
                                                handlePersonalInformation(
                                                  item.sections_labels_id,
                                                  e.target.value,
                                                  "email", // pass inputType
                                                )
                                              }
                                            />
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}

                                        {/* PHONE NUMBER FIELD */}
                                        {inputType === "phoneno" && (
                                          <>
                                            <div
                                              style={{
                                                display: "flex",
                                                alignItems: "center",
                                                border: "1px solid #ced4da",
                                                borderRadius: "6px",
                                                overflow: "visible",
                                                backgroundColor: isDisabled
                                                  ? "#e9ecef"
                                                  : "white",
                                                opacity: isDisabled ? 0.7 : 1,
                                                position: "relative",
                                              }}
                                            >
                                              {/* Custom Country Code Dropdown */}
                                              <div
                                                style={{
                                                  position: "relative",
                                                  flexShrink: 0,
                                                }}
                                                onBlur={(e) => {
                                                  if (
                                                    !e.currentTarget.contains(
                                                      e.relatedTarget,
                                                    )
                                                  ) {
                                                    setpersonalInformationValues(
                                                      (prev) => ({
                                                        ...prev,
                                                        [`phone_dropdown_open_${item.sections_labels_id}`]: false,
                                                        [`phone_dropdown_search_${item.sections_labels_id}`]:
                                                          "",
                                                      }),
                                                    );
                                                  }
                                                }}
                                              >
                                                {/* Trigger button */}
                                                <button
                                                  type="button"
                                                  disabled={isDisabled}
                                                  onClick={() =>
                                                    setpersonalInformationValues(
                                                      (prev) => ({
                                                        ...prev,
                                                        [`phone_dropdown_open_${item.sections_labels_id}`]:
                                                          !prev[
                                                          `phone_dropdown_open_${item.sections_labels_id}`
                                                          ],
                                                      }),
                                                    )
                                                  }
                                                  style={{
                                                    border: "none",
                                                    outline: "none",
                                                    backgroundColor:
                                                      "transparent",
                                                    padding: "9px 8px 9px 12px",
                                                    fontSize: "14px",
                                                    cursor: isDisabled
                                                      ? "not-allowed"
                                                      : "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "4px",
                                                    color: "#333",
                                                    whiteSpace: "nowrap",
                                                    minWidth: "80px",
                                                  }}
                                                >
                                                  <span>
                                                    {(() => {
                                                      const selected =
                                                        countryCodes.find(
                                                          (c) =>
                                                            String(
                                                              c.country_id,
                                                            ) ===
                                                            String(
                                                              selectedCountryCodes[
                                                                item
                                                                  .sections_labels_id
                                                              ]?.country_id,
                                                            ),
                                                        );
                                                      return selected
                                                        ? `+${selected.country_code}`
                                                        : "+--";
                                                    })()}
                                                  </span>
                                                  <svg
                                                    width="12"
                                                    height="12"
                                                    viewBox="0 0 12 12"
                                                    fill="none"
                                                  >
                                                    <path
                                                      d="M2 4L6 8L10 4"
                                                      stroke="#666"
                                                      strokeWidth="1.5"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                  </svg>
                                                </button>

                                                {/* Dropdown list */}
                                                {personalInformationValues[
                                                  `phone_dropdown_open_${item.sections_labels_id}`
                                                ] &&
                                                  !isDisabled && (
                                                    <div
                                                      style={{
                                                        position: "absolute",
                                                        top: "calc(100% + 4px)",
                                                        left: 0,
                                                        zIndex: 9999,
                                                        backgroundColor:
                                                          "white",
                                                        border:
                                                          "1px solid #ced4da",
                                                        borderRadius: "6px",
                                                        boxShadow:
                                                          "0 4px 16px rgba(0,0,0,0.12)",
                                                        minWidth: "260px",
                                                      }}
                                                    >
                                                      {/* Search input */}
                                                      <div
                                                        style={{
                                                          padding: "8px",
                                                          borderBottom:
                                                            "1px solid #ced4da",
                                                          position: "sticky",
                                                          top: 0,
                                                          backgroundColor:
                                                            "white",
                                                          zIndex: 1,
                                                        }}
                                                      >
                                                        <input
                                                          type="text"
                                                          autoFocus
                                                          placeholder={
                                                            selectedLanguage.id ===
                                                              1
                                                              ? "Search country or code..."
                                                              : "Rechercher un pays ou un code..."
                                                          }
                                                          value={
                                                            personalInformationValues[
                                                            `phone_dropdown_search_${item.sections_labels_id}`
                                                            ] || ""
                                                          }
                                                          onMouseDown={(e) =>
                                                            e.stopPropagation()
                                                          }
                                                          onChange={(e) =>
                                                            setpersonalInformationValues(
                                                              (prev) => ({
                                                                ...prev,
                                                                [`phone_dropdown_search_${item.sections_labels_id}`]:
                                                                  e.target
                                                                    .value,
                                                              }),
                                                            )
                                                          }
                                                          style={{
                                                            width: "100%",
                                                            border:
                                                              "1px solid #ced4da",
                                                            borderRadius: "4px",
                                                            padding: "6px 10px",
                                                            fontSize: "13px",
                                                            outline: "none",
                                                          }}
                                                        />
                                                      </div>

                                                      {/* Filtered list */}
                                                      <div
                                                        style={{
                                                          maxHeight: "200px",
                                                          overflowY: "auto",
                                                        }}
                                                      >
                                                        {(() => {
                                                          const searchTerm = (
                                                            personalInformationValues[
                                                            `phone_dropdown_search_${item.sections_labels_id}`
                                                            ] || ""
                                                          )
                                                            .toLowerCase()
                                                            .trim();

                                                          const filtered =
                                                            countryCodes.filter(
                                                              (country) => {
                                                                if (!searchTerm)
                                                                  return true;
                                                                return (
                                                                  country.country_name
                                                                    .toLowerCase()
                                                                    .includes(
                                                                      searchTerm,
                                                                    ) ||
                                                                  String(
                                                                    country.country_code,
                                                                  ).includes(
                                                                    searchTerm,
                                                                  )
                                                                );
                                                              },
                                                            );

                                                          if (
                                                            filtered.length ===
                                                            0
                                                          ) {
                                                            return (
                                                              <div
                                                                style={{
                                                                  padding:
                                                                    "12px 14px",
                                                                  fontSize:
                                                                    "14px",
                                                                  color: "#888",
                                                                  textAlign:
                                                                    "center",
                                                                }}
                                                              >
                                                                No results found
                                                              </div>
                                                            );
                                                          }

                                                          return filtered.map(
                                                            (country) => (
                                                              <div
                                                                key={
                                                                  country.country_id
                                                                }
                                                                onMouseDown={(
                                                                  e,
                                                                ) => {
                                                                  e.preventDefault();
                                                                  setSelectedCountryCodes(
                                                                    (prev) => ({
                                                                      ...prev,
                                                                      [item.sections_labels_id]:
                                                                      {
                                                                        country_id:
                                                                          country.country_id,
                                                                      },
                                                                    }),
                                                                  );
                                                                  setpersonalInformationValues(
                                                                    (prev) => ({
                                                                      ...prev,
                                                                      [`phone_dropdown_open_${item.sections_labels_id}`]: false,
                                                                      [`phone_dropdown_search_${item.sections_labels_id}`]:
                                                                        "",
                                                                    }),
                                                                  );
                                                                }}
                                                                style={{
                                                                  padding:
                                                                    "8px 14px",
                                                                  fontSize:
                                                                    "14px",
                                                                  cursor:
                                                                    "pointer",
                                                                  backgroundColor:
                                                                    String(
                                                                      selectedCountryCodes[
                                                                        item
                                                                          .sections_labels_id
                                                                      ]
                                                                        ?.country_id,
                                                                    ) ===
                                                                      String(
                                                                        country.country_id,
                                                                      )
                                                                      ? "#f0f4ff"
                                                                      : "white",
                                                                  color: "#333",
                                                                  whiteSpace:
                                                                    "nowrap",
                                                                }}
                                                                onMouseEnter={(
                                                                  e,
                                                                ) =>
                                                                (e.currentTarget.style.backgroundColor =
                                                                  "#f5f5f5")
                                                                }
                                                                onMouseLeave={(
                                                                  e,
                                                                ) =>
                                                                (e.currentTarget.style.backgroundColor =
                                                                  String(
                                                                    selectedCountryCodes[
                                                                      item
                                                                        .sections_labels_id
                                                                    ]
                                                                      ?.country_id,
                                                                  ) ===
                                                                    String(
                                                                      country.country_id,
                                                                    )
                                                                    ? "#f0f4ff"
                                                                    : "white")
                                                                }
                                                              >
                                                                +
                                                                {
                                                                  country.country_code
                                                                }
                                                                &nbsp;&nbsp;
                                                                {
                                                                  country.country_name
                                                                }
                                                              </div>
                                                            ),
                                                          );
                                                        })()}
                                                      </div>
                                                    </div>
                                                  )}
                                              </div>

                                              {/* Vertical divider */}
                                              <div
                                                style={{
                                                  width: "1px",
                                                  height: "24px",
                                                  backgroundColor: "#ced4da",
                                                  flexShrink: 0,
                                                }}
                                              />

                                              {/* Phone number input */}
                                              <input
                                                type="tel"
                                                placeholder={item.placeholder}
                                                disabled={isDisabled}
                                                value={value}
                                                style={{
                                                  border: "none",
                                                  outline: "none",
                                                  flex: 1,
                                                  minWidth: "0",
                                                  padding: "8px 10px",
                                                  fontSize: "14px",
                                                  backgroundColor:
                                                    "transparent",
                                                  cursor: isDisabled
                                                    ? "not-allowed"
                                                    : "text",
                                                }}
                                                onChange={(e) => {
                                                  const localVal =
                                                    e.target.value.replace(
                                                      /[^0-9]/g,
                                                      "",
                                                    );
                                                  handlePersonalInformation(
                                                    item.sections_labels_id,
                                                    localVal,
                                                    "phoneno",
                                                  );
                                                }}
                                              />
                                            </div>

                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-1">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}
                                        {/* CHECKBOX DECLARATION */}
                                        {inputType ===
                                          "checkbox_declaration" && (
                                            <div className="form-check fst-italic d-flex align-items-start gap-2">
                                              <input
                                                type="checkbox"
                                                className="form-check-input mt-1"
                                                checked={value || false}
                                                onChange={(e) =>
                                                  handlePersonalInformation(
                                                    item.sections_labels_id,
                                                    e.target.checked,
                                                  )
                                                }
                                              />

                                              <p className="mb-0">
                                                {item.placeholder}
                                                {item.label_mandatory === "Yes" &&
                                                  !isDisabled && (
                                                    <span className="text-danger">
                                                      {" "}
                                                      *
                                                    </span>
                                                  )}
                                                {personalInformationErr[
                                                  item.sections_labels_id
                                                ] && (
                                                    <>
                                                      <br />
                                                      <small className="text-danger d-block mt-2">
                                                        {
                                                          personalInformationErr[
                                                          item.sections_labels_id
                                                          ]
                                                        }
                                                      </small>
                                                    </>
                                                  )}
                                              </p>
                                            </div>
                                          )}

                                        {/* IMAGE / FILE UPLOAD */}
                                        {inputType === "image" && (
                                          <>
                                            <div
                                              className={`rounded-3 p-4 text-center position-relative bg-white ${isDisabled ? "disabled-field opacity-75" : ""}`}
                                              style={{
                                                border: "2px dashed grey",
                                                minHeight: "250px",
                                                cursor: isDisabled
                                                  ? "not-allowed"
                                                  : "pointer",
                                              }}
                                            >
                                              <input
                                                type="file"
                                                disabled={isDisabled}
                                                multiple={
                                                  !isSignatureField(item)
                                                }
                                                accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                                                onChange={(e) => {
                                                  handleFileChange(
                                                    item.sections_labels_id,
                                                    e,
                                                    isSignatureField(item),
                                                  );
                                                  e.target.value = null;
                                                }}
                                                className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                                                style={{
                                                  cursor: "pointer",
                                                  zIndex: 2,
                                                }}
                                              />
                                              {(!uploadedFiles[
                                                item.sections_labels_id
                                              ] ||
                                                uploadedFiles[
                                                  item.sections_labels_id
                                                ].length === 0) && (
                                                  <div className="h-100 d-flex flex-column align-items-center justify-content-center">
                                                    <div
                                                      className="rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center mb-3"
                                                      style={{
                                                        width: "60px",
                                                        height: "60px",
                                                      }}
                                                    >
                                                      <i className="bi bi-upload text-primary fs-3"></i>
                                                    </div>
                                                    <p className="mb-0 fs-5 text-dark">
                                                      Drop your files here or
                                                      click to upload
                                                    </p>
                                                  </div>
                                                )}
                                              {uploadedFiles[
                                                item.sections_labels_id
                                              ]?.length > 0 && (
                                                  <div className="d-flex flex-wrap justify-content-center gap-4 mt-2">
                                                    {uploadedFiles[
                                                      item.sections_labels_id
                                                    ].map((file, index) => (
                                                      <div
                                                        key={index}
                                                        className="position-relative"
                                                      >
                                                        {file.type?.startsWith(
                                                          "image/",
                                                        ) ? (
                                                          <img
                                                            src={file.preview}
                                                            alt={file.name}
                                                            className="img-fluid"
                                                            style={{
                                                              maxHeight: "180px",
                                                              objectFit:
                                                                "contain",
                                                              pointerEvents:
                                                                "none",
                                                            }}
                                                          />
                                                        ) : (
                                                          <div
                                                            className="border rounded-3 bg-light d-flex align-items-center justify-content-center px-3 py-4"
                                                            style={{
                                                              width: "220px",
                                                              minHeight: "120px",
                                                            }}
                                                          >
                                                            <span className="text-break small">
                                                              {file.name}
                                                            </span>
                                                          </div>
                                                        )}
                                                        <button
                                                          type="button"
                                                          className="btn btn-danger btn-sm rounded-3 position-absolute top-0 end-0 m-2 d-flex align-items-center justify-content-center"
                                                          style={{
                                                            width: "36px",
                                                            height: "36px",
                                                            zIndex: 5,
                                                          }}
                                                          onClick={(e) => {
                                                            e.stopPropagation();
                                                            setUploadedFiles(
                                                              (prev) => ({
                                                                ...prev,
                                                                [item.sections_labels_id]:
                                                                  prev[
                                                                    item
                                                                      .sections_labels_id
                                                                  ].filter(
                                                                    (_, i) =>
                                                                      i !== index,
                                                                  ),
                                                              }),
                                                            );
                                                            setpersonalInformationValues(
                                                              (prev) => ({
                                                                ...prev,
                                                                [item.sections_labels_id]:
                                                                  (
                                                                    prev[
                                                                    item
                                                                      .sections_labels_id
                                                                    ] || []
                                                                  ).filter(
                                                                    (_, i) =>
                                                                      i !== index,
                                                                  ),
                                                              }),
                                                            );
                                                          }}
                                                        >
                                                          <i className="bi bi-trash"></i>
                                                        </button>
                                                      </div>
                                                    ))}
                                                  </div>
                                                )}
                                            </div>
                                            {personalInformationErr[
                                              item.sections_labels_id
                                            ] && (
                                                <small className="text-danger d-block mt-2">
                                                  {
                                                    personalInformationErr[
                                                    item.sections_labels_id
                                                    ]
                                                  }
                                                </small>
                                              )}
                                          </>
                                        )}
                                      </div>
                                    );
                                  })}
                              </div>
                            </div>
                          )),
                      )}

                    <div class="text-end mt-4">
                      <button
                        class="submit-btn"
                        onClick={SubmitButton}
                        disabled={isSubmitting}
                        style={{
                          opacity: isSubmitting ? 0.6 : 1,
                          cursor: isSubmitting ? "not-allowed" : "pointer",
                        }}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              class="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>

                            {selectedLanguage.id === 1
                              ? "Submitting..."
                              : "Soumission..."}
                          </>
                        ) : selectedLanguage.id === 1 ? (
                          "Submit"
                        ) : (
                          "Soumettre"
                        )}
                      </button>
                    </div>
                    {/* <div className="Enquiry-section mt-4">
                                {selectedLanguage.id === 1 ? (
                                    <p> For any enquiry, please contact us:info@asraimmigration.ca | Phone: +1 (613) 227 8127 </p>
                                ) : (
                                    <p>Pour toute question, veuillez nous contacter :info@asraimmigration.ca | Téléphone : +1 (613) 227 8127 </p>
                                )}
                            </div> */}
                    {showModal && (
                      <div
                        className="modal fade show d-block"
                        id="successModal"
                        tabIndex="-1"
                      >
                        <div className="modal-dialog modal-dialog-centered">
                          <div className="modal-content">
                            <div className="modal-body text-center p-4">
                              {loading ? (
                                <>
                                  <div
                                    className="spinner-border text-danger mb-3"
                                    role="status"
                                  />

                                  <p className="mb-0">
                                    {selectedLanguage.id === 1
                                      ? "Processing your request..."
                                      : "Traitement de votre demande..."}
                                  </p>
                                </>
                              ) : (
                                <>
                                  <h5 className="modal-title mb-3">
                                    {selectedLanguage.id === 1
                                      ? "Request has been sent"
                                      : "La demande a été envoyée"}
                                  </h5>
                                  <img
                                    src={popupsuccessimg}
                                    alt="Success"
                                    className="mb-4"
                                    style={{ maxWidth: "200px" }}
                                  />

                                  <p className="mb-2">
                                    {selectedLanguage.id === 1
                                      ? "We have received your appointment request. We will get back to you with the next steps."
                                      : "Nous avons bien reçu votre demande de rendez-vous. Nous vous recontacterons avec les prochaines étapes."}
                                  </p>
                                  <button
                                    type="button"
                                    className="btn btn-danger mt-3"
                                    onClick={() => {
                                      setShowModal(false);
                                      setIsSubmitting(false);
                                      navigate("/bookingform");
                                    }}
                                  >
                                    {selectedLanguage.id === 1
                                      ? "Close"
                                      : "Fermer"}
                                  </button>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BookingIntakeForm;
